import styled from "styled-components";

export const Container = styled.div`
  @media (max-width: 640px) {
    display: flex;
    flex-direction: column;

    width: 100%;
    max-width: 400px;

    padding: 0;
    overflow: auto;
    margin-bottom: 2rem;
  }

  width: 100%;
  height: 100%;
  max-width: 1120px;

  margin-top: 7.5rem;
  padding: 0 2rem;

  display: flex;
  flex: 1;
  flex-direction: column;

  h1 {
    margin-bottom: 5.625rem;
    color: #495156;
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  .react-div_accepted {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 100%;

    p {
      color: #495156;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      letter-spacing: 0.8px;
      margin-top: 32px;
      /* margin-bottom: 16px; */
      padding: 0 20px;
      line-height: 25px;
    }

    .tagline {
      color: #495156;
      text-align: center;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 24px */
      letter-spacing: 0.8px;
      margin-top: 16px;
    }

    span {
      margin-bottom: 14.625rem;
      color: #2aaeae;
      text-align: center;

      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 18px; /* 75% */
      letter-spacing: 1.2px;
    }

    .info-plan-container {
      margin: 0;
      margin-top: 32px;
      display: flex;
      flex-direction: column;

      span {
        margin: 0;
        margin-bottom: 16px;
        color: #2AAEAE;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
      }

      &:last-child {
        margin-bottom: 120px;
      }
    }

  }

  @media (min-width: 640px) {

    h1 {
        font-size: 36px;
        
    }

    .react-div_accepted {
      p {
        font-size: 24px;
        letter-spacing: 1.2px;
      }
      span {
        font-size: 24px;
      }
    }
  }
`;

export const Form = styled.form`
  @media (max-width: 640px) {
    display: flex;
    flex-direction: column;
    margin-top: 6rem;

    padding: 10px;

    h1 {
      font-size: 1.25rem;
      margin-bottom: 1rem;
    }
  }

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin-top: 3rem;

  .form-check {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 0;

    input {
      min-width: 20px;
      min-height: 20px;
      margin-right: 20px;
      position: unset;
      margin-top: 0;
      margin-left: 0;
    }
  }

  .form-check-label {
    margin-left: 0;
    display: flex;
    align-items: center;
  }
`;

export const ButtonContainer = styled.div`
  @media (max-width: 640px) {
    flex-direction: column;

    .secondary-button {
      margin-bottom: 25px;
    }
  }
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-top: 2rem;
  margin-bottom: 2rem;

  button {
    width: 183px;
    height: 47px;
  }
`;
